import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    back: string;
    next: string;
    done: string;
    close: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the back button in multi-step tooltips */
            back: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OnboardingTooltipContainer.back?c=2sja1esxksx0w", defaultMessage: "Back" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the next button in multi-step tooltips */
            next: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OnboardingTooltipContainer.next?c=f7vl39fzsr7q", defaultMessage: "Next" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the done button in multi-step tooltips */
            done: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OnboardingTooltipContainer.done?c=1qtcbgq8drjyi", defaultMessage: "Done" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the close button in tooltips */
            close: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OnboardingTooltipContainer.close?c=1h3mba94p9xl7", defaultMessage: "Close" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
